module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cefta-159b824020be52ab9a1db4df65acf301.svg";